import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={companyInfo.logo} 
                alt="Barchalo Logo" 
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Building excellence across South Africa with premium construction and formwork solutions.
            </p>
            <div className="flex gap-4">
              <a 
                href={companyInfo.socials.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-sm bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-yellow-500 hover:text-slate-900 transition-all duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href={companyInfo.socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-sm bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-yellow-500 hover:text-slate-900 transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href={companyInfo.socials.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-sm bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-yellow-500 hover:text-slate-900 transition-all duration-300"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-yellow-500 transition-colors duration-300 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-yellow-500 transition-colors duration-300 text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-slate-400 hover:text-yellow-500 transition-colors duration-300 text-sm">
                  Our Portfolio
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-yellow-500 transition-colors duration-300 text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li className="text-slate-400 text-sm">Residential Construction</li>
              <li className="text-slate-400 text-sm">Commercial Construction</li>
              <li className="text-slate-400 text-sm">Formwork Solutions</li>
              <li className="text-slate-400 text-sm">Industrial Projects</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wide mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-start gap-3 text-slate-400 hover:text-yellow-500 transition-colors duration-300 group"
                >
                  <Phone className="w-5 h-5 mt-0.5 text-yellow-500 group-hover:text-yellow-400" />
                  <span className="text-sm">{companyInfo.phone}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-start gap-3 text-slate-400 hover:text-yellow-500 transition-colors duration-300 group"
                >
                  <Mail className="w-5 h-5 mt-0.5 text-yellow-500 group-hover:text-yellow-400" />
                  <span className="text-sm">{companyInfo.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <MapPin className="w-5 h-5 mt-0.5 text-yellow-500" />
                  <span className="text-sm">{companyInfo.address}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} {companyInfo.fullName}. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            BIBC Registered | Reg: {companyInfo.registrationNumber}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
